export { default } from "./Deals";
